import { useEffect } from "react";

// Lightweight SEO / structured-data injector for prerendering-compatible indexing.
export default function Seo({ title, description, image, url, video }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — VytaliFlix` : "VytaliFlix";
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", video ? "video.other" : "website");
    setMeta("property", "og:image", image);
    setMeta("property", "og:url", url || window.location.href);
    setMeta("name", "twitter:card", "summary_large_image");

    let ld = document.getElementById("vf-jsonld");
    if (video) {
      const data = {
        "@context": "https://schema.org",
        "@type": "VideoObject",
        name: title,
        description: description,
        thumbnailUrl: image,
        uploadDate: video.uploadDate,
        duration: video.duration,
      };
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "vf-jsonld";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(data);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, image, url, video]);

  return null;
}
